
    <div class="ModalContainer"
      (click)="$event.stopPropagation()"
      [ngClass]="{
        SmallSize: size === 'small',
        MidSize: size === 'mid',
        LargeSize: size === 'large'
      }"
    >
      <ng-container #modalContent></ng-container>
    </div>
  


// WEBPACK FOOTER //
// ./src/@freelancer/ui/modal/modal.component.ts.ModalComponent.html